// extracted by mini-css-extract-plugin
module.exports = {"modulesListInput":"ModuleSelector_modulesListInput__2Qvqs","moduleSelector":"ModuleSelector_moduleSelector__2zMYB"};